export default __webpack_public_path__ + "static/media/flag-fi.8be4b9bc.svg";